module.exports = __webpack_public_path__ + "img/riba_2.534ebf0d.png";